import values from 'lodash/values';

import * as productEventsListener from './productListener';
import * as promotionEventsListener from './promotionsListener';

export default [
    ...values(productEventsListener),
    ...values(promotionEventsListener),
];